<template>
  <span>
    <v-row class="mx-auto">
      <v-col class="pb-0 pt-1" cols="6">
        <input-month 
          label="Competência de*"
          rules="required|min:7"
          :selectedMonth="data_de"
          @monthSelected="setDataDe"
        />
      </v-col>
      <v-col class="pb-0 pt-1" cols="6">
        <input-month 
          label="Competência até*"
          rules="required|min:7"
          :selectedMonth="data_ate"
          @monthSelected="setDataAte"
        />  
      </v-col>
    </v-row>

    <v-row class="mx-auto">
      <v-col 
        class="pb-0 pt-1" 
        cols="2" 
        v-for="(label, value) in temasValidos" 
        :key="value"
      >
        <v-checkbox 
          v-model="temas_selecionados"
          :label="label"
          :value="value"
        />
      </v-col>
    </v-row>
  </span>
</template>

<script>

export default {

  name: 'Reclamacao',
  
  components: {
    InputMonth: () => import('@/components/general/InputMonth.vue'), 
  },

  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      data_de: '',
      data_ate: '',
      temasValidos: {
        Anexo1: 'Anexo 1',
        LigacoesNovas: 'Ligações Novas',
        GeracaoDistribuida: 'Geração Distribuída',
        DanosEletricos: 'Danos Elétricos'
      },
      temas_selecionados: [
        'Anexo1',
        'LigacoesNovas',
        'GeracaoDistribuida',
        'DanosEletricos'
      ]
    }
  },

  methods: {
    
    setDataDe(data) {
      this.data_de = data;
      this.filtersUpdated();
    },
    
    setDataAte(data) {
      this.data_ate = data;
      this.filtersUpdated();
    },
    
    filtersUpdated() {
      this.$emit('filtersUpdated', {
        data_de: this.data_de,
        data_ate: this.data_ate,
        temas_selecionados: this.temas_selecionados
      });
    }
  },

  watch: {

    item(newVal) {
      Object.assign(this.$data, newVal.filtros);
    },

    temas_selecionados() {
      this.filtersUpdated();
    }
  }
}

</script>